
<div class="recpatcha-container captcha_width">
    <!-- *ngIf="displayCaptcha" -->
    <!-- [(ngModel)]="forgotPasswordModel.captchaToken" -->
    <re-captcha #recaptcha name="recaptcha" 
        [(ngModel)]="captchaToken"></re-captcha>

</div>